import ModalSideBar from './side-bar';

export default ModalSideBar;